import { FC } from 'react';
import { useGetCourseObjectivesQuery } from '@teachur/http-client';
import { Loader } from '@new/common/ui/Loader/Loader';
import { EmptyState } from '@new/common/ui/EmptyState/EmptyState';
import { CourseObjectiveRow } from './CourseObjectiveRow';

interface CourseObjectivesTabProps {
  courseId: number;
}

export const CourseObjectivesTab: FC<CourseObjectivesTabProps> = ({ courseId }) => {
  const { data: objectives, isLoading, isError } = useGetCourseObjectivesQuery(courseId);

  if (isLoading) {
    return <Loader />;
  }

  // Only treat it as an error when we have nothing to render — a background
  // refetch failure while objectives from the previous success are still cached
  // keeps the list visible.
  if (isError && !objectives) {
    return (
      <EmptyState
        message="Couldn't load the objectives for this course."
        description="Please try refreshing the page in a moment."
      />
    );
  }

  if (!objectives || objectives.length === 0) {
    return <EmptyState message="No objectives found for this course." />;
  }

  return (
    <div className="flex flex-col gap-4">
      <h3 className="m-0! [font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB1000)!">
        Objectives
      </h3>
      <div className="flex flex-col gap-2">
        {objectives.map((objective) => (
          <CourseObjectiveRow key={objective.id} objective={objective} />
        ))}
      </div>
    </div>
  );
};
